interface Props {
  mobile: boolean;
}
const SvgAdditionDetails: React.FC<Props> = ({ mobile }) => {
  return (
    <svg
      style={{ transform: mobile ? "" : "scale(1.13)" }}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_12125_55570)">
        <path
          d="M8.00016 1.33301C4.32418 1.33301 1.3335 4.3237 1.3335 7.99967C1.3335 11.6757 4.32418 14.6663 8.00016 14.6663C11.6761 14.6663 14.6668 11.6757 14.6668 7.99967C14.6668 4.3237 11.6761 1.33301 8.00016 1.33301ZM8.00016 2.33301C11.1357 2.33301 13.6668 4.86414 13.6668 7.99967C13.6668 11.1352 11.1357 13.6663 8.00016 13.6663C4.86462 13.6663 2.3335 11.1352 2.3335 7.99967C2.3335 4.86414 4.86462 2.33301 8.00016 2.33301ZM8.00016 4.66634C7.82335 4.66634 7.65378 4.73658 7.52876 4.8616C7.40373 4.98663 7.3335 5.1562 7.3335 5.33301C7.3335 5.50982 7.40373 5.67939 7.52876 5.80441C7.65378 5.92944 7.82335 5.99967 8.00016 5.99967C8.17697 5.99967 8.34654 5.92944 8.47157 5.80441C8.59659 5.67939 8.66683 5.50982 8.66683 5.33301C8.66683 5.1562 8.59659 4.98663 8.47157 4.8616C8.34654 4.73658 8.17697 4.66634 8.00016 4.66634ZM7.99235 6.99251C7.85986 6.99458 7.7336 7.04916 7.64131 7.14425C7.54903 7.23934 7.49826 7.36718 7.50016 7.49967V11.1663C7.49923 11.2326 7.51147 11.2984 7.53617 11.3599C7.56088 11.4213 7.59756 11.4773 7.64408 11.5245C7.69061 11.5717 7.74604 11.6091 7.80717 11.6347C7.8683 11.6603 7.9339 11.6735 8.00016 11.6735C8.06643 11.6735 8.13203 11.6603 8.19316 11.6347C8.25428 11.6091 8.30972 11.5717 8.35624 11.5245C8.40276 11.4773 8.43945 11.4213 8.46415 11.3599C8.48886 11.2984 8.5011 11.2326 8.50016 11.1663V7.49967C8.50112 7.43275 8.48864 7.36632 8.46345 7.30431C8.43826 7.2423 8.40088 7.18598 8.35353 7.13869C8.30617 7.09139 8.2498 7.05408 8.18776 7.02897C8.12572 7.00387 8.05927 6.99147 7.99235 6.99251Z"
          fill="#262626"
        />
      </g>
      <defs>
        <clipPath id="clip0_12125_55570">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SvgAdditionDetails;
